import React, { useState } from 'react';
import './interactive.css';

const KerasjiekPreview = () => {
  const [activeTab, setActiveTab] = useState('cms');
  const [heroTitle, setHeroTitle] = useState('Kerasjiek – Exclusieve Kapsalon & Styling');
  const [showBooking, setShowBooking] = useState(true);
  const [showHours, setShowHours] = useState(true);
  const [savedNotification, setSavedNotification] = useState(false);

  const handleSaveCms = (e) => {
    e.preventDefault();
    setSavedNotification(true);
    setTimeout(() => setSavedNotification(false), 2500);
  };

  return (
    <div className="interactive-box">
      <div className="interactive-header">
        <div className="interactive-title">
          <i className="fas fa-sliders-h" style={{ color: '#059669' }}></i> Kerasjiek.nl – Maatwerk CMS & Performance
        </div>
        <div>
          <a
            href="https://kerasjiek.nl"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#059669', fontSize: '0.8rem', textDecoration: 'none', fontWeight: 600 }}
          >
            kerasjiek.nl <i className="fas fa-external-link-alt"></i>
          </a>
        </div>
      </div>

      <div className="interactive-content">
        <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.25rem', flexWrap: 'wrap' }}>
          <button
            type="button"
            className={`ansible-btn ${activeTab === 'cms' ? '' : 'ansible-btn--secondary'}`}
            style={{ padding: '0.45rem 1rem', fontSize: '0.8125rem' }}
            onClick={() => setActiveTab('cms')}
          >
            <i className="fas fa-edit"></i> CMS Editor Demo
          </button>
          <button
            type="button"
            className={`ansible-btn ${activeTab === 'lighthouse' ? '' : 'ansible-btn--secondary'}`}
            style={{ padding: '0.45rem 1rem', fontSize: '0.8125rem' }}
            onClick={() => setActiveTab('lighthouse')}
          >
            <i className="fas fa-tachometer-alt"></i> Core Web Vitals & Caddy
          </button>
          <button
            type="button"
            className={`ansible-btn ${activeTab === 'live' ? '' : 'ansible-btn--secondary'}`}
            style={{ padding: '0.45rem 1rem', fontSize: '0.8125rem' }}
            onClick={() => setActiveTab('live')}
          >
            <i className="fas fa-globe"></i> Live Website
          </button>
        </div>

        {activeTab === 'cms' && (
          <div>
            <p style={{ fontSize: '0.875rem', color: 'var(--text-color)', margin: '0 0 1rem 0' }}>
              Test het maatwerk Content Management Systeem dat ik voor de klant heb gebouwd. Pas hieronder de instellingen aan en zie direct live hoe de website meeverandert:
            </p>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.25rem' }}>
              {/* CMS Admin Controls */}
              <form onSubmit={handleSaveCms} style={{ background: 'rgba(0,0,0,0.02)', padding: '1.25rem', borderRadius: '12px', border: '1px solid rgba(0,0,0,0.08)' }}>
                <div style={{ fontSize: '0.8125rem', fontWeight: 'bold', color: '#059669', marginBottom: '0.85rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                  <i className="fas fa-cog"></i> CMS Beheerpaneel
                </div>

                <div style={{ marginBottom: '1rem' }}>
                  <label style={{ display: 'block', fontSize: '0.8rem', color: 'var(--title-color)', fontWeight: 600, marginBottom: '0.4rem' }}>
                    Koptekst (Hero Title):
                  </label>
                  <input
                    type="text"
                    value={heroTitle}
                    onChange={(e) => setHeroTitle(e.target.value)}
                    style={{
                      width: '100%',
                      background: 'var(--container-color)',
                      border: '1px solid rgba(0,0,0,0.12)',
                      borderRadius: '8px',
                      padding: '0.55rem 0.75rem',
                      color: 'var(--title-color)',
                      fontSize: '0.85rem',
                      outline: 'none'
                    }}
                  />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.65rem', marginBottom: '1.25rem' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', fontSize: '0.84rem', cursor: 'pointer', color: 'var(--title-color)', fontWeight: 500 }}>
                    <input
                      type="checkbox"
                      checked={showBooking}
                      onChange={(e) => setShowBooking(e.target.checked)}
                      style={{ accentColor: '#059669', width: '16px', height: '16px' }}
                    />
                    Online Afspraak Boeken module actief
                  </label>

                  <label style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', fontSize: '0.84rem', cursor: 'pointer', color: 'var(--title-color)', fontWeight: 500 }}>
                    <input
                      type="checkbox"
                      checked={showHours}
                      onChange={(e) => setShowHours(e.target.checked)}
                      style={{ accentColor: '#059669', width: '16px', height: '16px' }}
                    />
                    Openingstijden badge tonen in header
                  </label>
                </div>

                <button
                  type="submit"
                  className="ansible-btn"
                  style={{ width: '100%', justifyContent: 'center', background: '#059669' }}
                >
                  <i className="fas fa-check"></i> Publiceer Wijziging via CMS
                </button>

                {savedNotification && (
                  <div style={{ marginTop: '0.75rem', color: '#10b981', fontSize: '0.8rem', textAlign: 'center', fontWeight: 600 }}>
                    <i className="fas fa-check-circle"></i> Wijzigingen live gesynchroniseerd naar backend!
                  </div>
                )}
              </form>

              {/* Live Preview Screen */}
              <div style={{ background: '#131728', borderRadius: '12px', overflow: 'hidden', border: '1px solid rgba(0,0,0,0.1)', display: 'flex', flexDirection: 'column' }}>
                <div style={{ background: '#0d101d', padding: '0.65rem 0.85rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                  <span style={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.6)', fontFamily: 'monospace' }}>
                    https://kerasjiek.nl/live-preview
                  </span>
                  <span style={{ fontSize: '0.68rem', background: '#059669', color: '#fff', padding: '0.2rem 0.5rem', borderRadius: '4px', fontWeight: 700 }}>
                    LIVE SYNC
                  </span>
                </div>

                <div style={{ padding: '1.5rem', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', background: 'linear-gradient(135deg, #131728 0%, #1a1f36 100%)' }}>
                  {showHours && (
                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', fontSize: '0.75rem', color: '#4ade80', background: 'rgba(74, 222, 128, 0.1)', padding: '0.25rem 0.65rem', borderRadius: '999px', marginBottom: '0.85rem', width: 'fit-content' }}>
                      <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#4ade80' }}></span>
                      Vandaag Geopend: 09:00 - 18:00
                    </div>
                  )}

                  <h4 style={{ fontSize: '1.2rem', color: '#fff', margin: '0 0 0.5rem 0', fontWeight: 700 }}>
                    {heroTitle || 'Kerasjiek'}
                  </h4>
                  <p style={{ fontSize: '0.84rem', color: 'rgba(255,255,255,0.75)', margin: '0 0 1.25rem 0', lineHeight: '1.6' }}>
                    Ervaar persoonlijke aandacht, professionele haarverzorging en de nieuwste trends in Veldhoven.
                  </p>

                  {showBooking ? (
                    <button
                      type="button"
                      style={{
                        background: '#d97706',
                        color: '#fff',
                        border: 'none',
                        padding: '0.55rem 1.15rem',
                        borderRadius: '6px',
                        fontSize: '0.8rem',
                        fontWeight: 600,
                        cursor: 'pointer',
                        width: 'fit-content',
                        boxShadow: '0 4px 12px rgba(217, 119, 6, 0.3)'
                      }}
                    >
                      <i className="fas fa-calendar-check" style={{ marginRight: '6px' }}></i> Online Afspraak Boeken
                    </button>
                  ) : (
                    <div style={{ fontSize: '0.78rem', color: 'rgba(255,255,255,0.5)', fontStyle: 'italic' }}>
                      Online boeken tijdelijk uitgeschakeld via CMS
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'lighthouse' && (
          <div>
            <p style={{ fontSize: '0.875rem', color: 'var(--text-color)', margin: '0 0 1rem 0' }}>
              Google Lighthouse audits & Core Web Vitals metingen voor Kerasjiek.nl (gehost op Caddy Web Server met HTTP/3):
            </p>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))', gap: '0.85rem', marginBottom: '1.25rem' }}>
              <div style={{ background: 'rgba(0,0,0,0.02)', padding: '1.25rem', borderRadius: '12px', textAlign: 'center', border: '1px solid rgba(74, 222, 128, 0.3)' }}>
                <div style={{ fontSize: '2rem', fontWeight: 800, color: '#10b981' }}>99</div>
                <div style={{ fontSize: '0.8rem', color: 'var(--title-color)', fontWeight: 600, marginTop: '0.25rem' }}>Performance</div>
              </div>
              <div style={{ background: 'rgba(0,0,0,0.02)', padding: '1.25rem', borderRadius: '12px', textAlign: 'center', border: '1px solid rgba(74, 222, 128, 0.3)' }}>
                <div style={{ fontSize: '2rem', fontWeight: 800, color: '#10b981' }}>100</div>
                <div style={{ fontSize: '0.8rem', color: 'var(--title-color)', fontWeight: 600, marginTop: '0.25rem' }}>Toegankelijkheid</div>
              </div>
              <div style={{ background: 'rgba(0,0,0,0.02)', padding: '1.25rem', borderRadius: '12px', textAlign: 'center', border: '1px solid rgba(74, 222, 128, 0.3)' }}>
                <div style={{ fontSize: '2rem', fontWeight: 800, color: '#10b981' }}>100</div>
                <div style={{ fontSize: '0.8rem', color: 'var(--title-color)', fontWeight: 600, marginTop: '0.25rem' }}>Best Practices</div>
              </div>
              <div style={{ background: 'rgba(0,0,0,0.02)', padding: '1.25rem', borderRadius: '12px', textAlign: 'center', border: '1px solid rgba(74, 222, 128, 0.3)' }}>
                <div style={{ fontSize: '2rem', fontWeight: 800, color: '#10b981' }}>100</div>
                <div style={{ fontSize: '0.8rem', color: 'var(--title-color)', fontWeight: 600, marginTop: '0.25rem' }}>SEO</div>
              </div>
            </div>

            <div style={{ background: 'rgba(0,0,0,0.02)', padding: '1.25rem', borderRadius: '12px', fontSize: '0.84rem', lineHeight: '1.7', border: '1px solid rgba(0,0,0,0.08)' }}>
              <div style={{ fontWeight: 'bold', color: 'var(--title-color)', marginBottom: '0.5rem', fontSize: '0.92rem' }}>
                <i className="fas fa-shield-alt" style={{ color: '#059669', marginRight: '6px' }}></i> Caddy Reverse Proxy & Web Architectuur:
              </div>
              <ul style={{ listStyle: 'disc', paddingLeft: '1.25rem', color: 'var(--text-color)', margin: 0 }}>
                <li><strong>Caddy Web Server:</strong> Automatische Let's Encrypt TLS 1.3 certificaatverlenging en HTTP/3 ondersteuning via QUIC protocol.</li>
                <li><strong>Core Web Vitals:</strong> Largest Contentful Paint (LCP) onder de 0.9s en Cumulative Layout Shift (CLS) van exact 0.00.</li>
                <li><strong>Gecachete Static Assets:</strong> Geoptimaliseerde WebP afbeeldingen en gzip/brotli compressie.</li>
              </ul>
            </div>
          </div>
        )}

        {activeTab === 'live' && (
          <div style={{ textAlign: 'center', padding: '2.5rem 1rem', background: 'rgba(0,0,0,0.02)', borderRadius: '12px', border: '1px solid rgba(0,0,0,0.08)' }}>
            <i className="fas fa-external-link-alt" style={{ fontSize: '2.5rem', color: '#059669', marginBottom: '1rem', display: 'block' }}></i>
            <h4 style={{ color: 'var(--title-color)', fontSize: '1.2rem', marginBottom: '0.5rem', fontWeight: 700 }}>Kerasjiek.nl Live Website</h4>
            <p style={{ color: 'var(--text-color)', fontSize: '0.875rem', maxWidth: '480px', margin: '0 auto 1.5rem auto' }}>
              De website draait 24/7 in productie op maatwerk Caddy infrastructuur.
            </p>
            <a
              href="https://kerasjiek.nl"
              target="_blank"
              rel="noopener noreferrer"
              className="ansible-btn"
              style={{ background: '#059669', padding: '0.65rem 1.5rem', fontSize: '0.88rem' }}
            >
              <i className="fas fa-globe"></i> Open Kerasjiek.nl in nieuw tabblad
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default KerasjiekPreview;
